<template>
    <swiper :options="swiperOption" ref="mySwiper" @slideChange="updatePagination">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in slideList" :key="index">
            <div class="item-wrap">
                 <!-- :style="'background-image:url('+item[imgUrl]+');'" -->
                <div class="show" @click="handle(index,slideList,imgUrl)">
                    <img :src="item[imgUrl]">
                </div>
            </div>
        </swiper-slide>
        <!-- Optional controls -->
        <div v-if="swiperOption.pagination != 'null'" class="swiper-pagination" slot="pagination">
            {{curIndex+1}}/{{slideList.length}}
        </div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-scrollbar"   slot="scrollbar"></div> -->
    </swiper>
</template>
<style>
.swiper-container{
    width: 100%;
    height: 100%;
}
/* .swiper-wrapper .swiper-slide{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
} */
.swiper-wrapper .swiper-slide .item-wrap{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.swiper-wrapper .swiper-slide .show{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}
.swiper-wrapper .swiper-slide .show img{
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
}

.swiper-pagination{
    width: auto;
    left: auto;
    right: 3%;
    bottom: 1rem;
    background-color: rgba(0,0,0,0.5);
    border-radius: 0.2rem;
    padding: 0.06rem 0.2rem;
    text-align: center;
    font-size: 0.26rem;
    color: #ffffff;
    line-height: 0.32rem;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
</style>
<script>
require('swiper/dist/css/swiper.css');
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
    //name: 'carrousel',
    props: {
        swiperOption: {
            // NotNextTick is a component's own property, and if notNextTick is set to true, the component will not instantiate the swiper through NextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
            // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
            notNextTick: true,
            // swiper configs 所有的配置同swiper官方api配置
            //initialSlide: 0,//设定初始化时slide的索引
            roundLengths : true,//设定为true将slide的宽和高取整(四舍五入)以防止某些分辨率的屏幕上文字或边界(border)模糊
            direction : 'horizontal',//Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)
            speed: 300,//滑动速度，即slider自动滑动开始到结束的时间（单位ms），也是触摸滑动时释放至贴合的时间，默认：300
            //autoplay: 3000,//自动切换的时间间隔（单位ms），不设定该参数slide不会自动切换
            autoplayDisableOnInteraction: false,//用户操作swiper之后，是否禁止autoplay。默认为true：停止
            //autoplayStopOnLast: false,//如果设置为true，当切换到最后一个slide时停止自动切换（loop模式下无效）
            grabCursor: true,//设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状（根据浏览器形状有所不同）
            effect: "slide",//切换效果，'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
            setWrapperSize :true,//Swiper从3.0开始使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽高，在对flexbox布局的支持不是很好的浏览器中可能需要用到
            // autoHeight: true,//自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
            pagination : 'null',//分页器容器的css选择器或HTML标签,'.swiper-pagination'
            paginationType:"bullets",//分页器样式类型
            paginationClickable :true,
            paginationHide: false,
            prevButton:'null',//前进按钮的css选择器或HTML元素,'.swiper-button-prev'
            nextButton:'null',//后退按钮的css选择器或HTML元素,'.swiper-button-next'
            // scrollbar:'.swiper-scrollbar',//Scrollbar容器的css选择器或HTML元素
            mousewheelControl : true,//是否开启鼠标控制Swiper切换。设置为true时，能使用鼠标滚轮控制slide滑动
            observeParents:false,
            slidesPerView: 1,
            loop: false,
            ////Slides grid（网格分布）
            //centeredSlides: false //设定为true时，活动块会居中，而不是默认状态下的居左
            //slidesPerView: 1 //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides
            //slidesPerGroup: 1 //在carousel mode下定义slides的数量多少为一组
            //spaceBetween: 0 //slide之间的距离（单位px）
            //slidesPerColumn: 1 //多行布局里面每列的slide数量
            //slidesPerColumnFill: column //多行布局中以什么形式填充，'column' or 'row'
            //slidesOffsetBefore: 0 //设定slide与左边框的预设偏移量（单位px）
            //slidesOffsetAfter: 0 //设定slide与右边框的预设偏移量（单位px）
            //followFinger: false //值为false时，仅当你释放slide时才会滑动，当你用手指按住滑块它不会动
                
            // if you need use plugins in the swiper, you can config in here like this
            // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
            // debugger: true,
            // swiper callbacks
            // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
            // onTransitionStart(swiper){
            //   console.log(swiper)
            // },
            // slideChange(swiper){
            //     console.log(111111111);
            // },
            // more Swiper configs and callbacks...
            // ...
            // ellipsisNum: {//标题显示行数，超出将用省略号代替
            //     type: Number,
            //     default: 1
            // },
        },
        slideList: { //数据列表
            type: Array,
            default: []
        },
        imgUrl: { //图片路径字段名称
            type: String,
            default: "ImageUrl"
        },
    },
    data() {
        return {
            curIndex: 0,
        }
    },
    components: {
        swiper,
        swiperSlide
    },
    // you can find current swiper instance object like this, while the notNextTick property value must be true
    // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        },
    },
    mounted() {
        let self = this;
        // you can use current swiper instance object to do something(swiper methods)
        // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
        // console.log('this is current swiper instance object', this.swiper)
        // this.swiper.slideTo(3, 1000, false)
        // console.log(this.slideList[0][this.imgUrl]);
        this.curIndex = this.swiper.realIndex;
    },
    methods: {
        handle(index,imgGroup){
            this.$emit("handle",index,imgGroup,this.imgUrl);
        },
        updatePagination(){
            let self = this;
            self.curIndex = self.swiper.realIndex;
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/shared/components/swiper/awesome-swiper.vue